import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faShoppingCart,
  faListAlt,
} from "@fortawesome/free-solid-svg-icons";
import Menu from "./MenuBottom.module.css";
import { Link, useLocation } from "react-router-dom";
import { getUserInfo } from "../../Api/BarestServices";
import { useTransferReasons } from "../../Context/TransferReasonContext";

const MenuBottom = () => {
  const location = useLocation();
  const [ShoppingBasket, setShoppingBasket] = useState(false);
  const [Home, setHome] = useState(true);
  const [Orders, setOrders] = useState(false);

  useEffect(() => {
    if (window.location.pathname === "/") {
      setShoppingBasket(false);
      setHome(true);
      setOrders(false);
    }
    if (window.location.pathname === "/shopp" || window.location.pathname==="/shopping") {
      setShoppingBasket(true);
      setHome(false);
      setOrders(false);
    }
    if (window.location.pathname === "/Orders") {
      setShoppingBasket(false);
      setHome(false);
      setOrders(true);
    }
  }, [location]);
  
  const { userInfoData } = useTransferReasons();
  const cartIconNumber=parseInt(userInfoData?.cart)+parseInt(userInfoData?.awaiting_payment_order)

  return (
    <ul className={Menu.menufixed}>
      <Link to="/shopp" >
        <li
          className={
            ShoppingBasket ? Menu.menufixed__li__click : Menu.menufixed__li
          }
        >
          <FontAwesomeIcon icon={faShoppingCart} />
          <h2 className={Menu.h2}>
            {" "}
            سبد خرید 
            { userInfoData.length!==0&&cartIconNumber!==0&&<span className={Menu.OrderCount}>{cartIconNumber}</span>}
          </h2>
        </li>
      </Link>
      <Link to="/">
        <li className={Home ? Menu.menufixed__li__click : Menu.menufixed__li}>
          <FontAwesomeIcon icon={faHome} />
          <h2 className={Menu.h2}> خانه</h2>
        </li>
      </Link>
      <Link to="/Orders">
        <li className={Orders ? Menu.menufixed__li__click : Menu.menufixed__li}>
          <FontAwesomeIcon icon={faListAlt} />
          <h2 className={Menu.h2}>سفارشات</h2>
        </li>
      </Link>
    </ul>
  );
};
export default MenuBottom;
